module.exports = __webpack_public_path__ + "assets/kruk.cf3faf8812fa6e627b372ae444a1f9c8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/home/kruk.png
 ** module id = 345
 ** module chunks = 0
 **/